import { UserApiUserLoginRequest } from "../../openapi/api";
import appApiClient from "./coreApiClient";
import useBaseMutation from "./useBaseMutation";

export const useLoginMutation = () =>
  useBaseMutation({
    mutationFn: (req: UserApiUserLoginRequest, config) =>
      appApiClient.userApi.userLogin(req, config),
  });
